import React from 'react';

import { Note } from '../../../styles/styledComponents';
import { LazyFigure, LazyFigcaption, LazyImageWrapper, LazyImageElement } from './styles.LazyImage';

interface Props {
    src: string;
    width: number;
    height: number;
    note?: string;
    isLazy?: boolean;
}

export const LazyImage: React.FC<Props> = ({ src, width, height, note, isLazy = true }) => {
    const paddingRatio = `${(height / width) * 100}%`;

    return (
        <LazyFigure>
            <LazyImageWrapper paddingBottom={paddingRatio}>
                <LazyImageElement src={src} alt={note} loading={isLazy ? 'lazy' : 'eager'} />
            </LazyImageWrapper>
            {note && (
                <LazyFigcaption>
                    <Note>{note}</Note>
                </LazyFigcaption>
            )}
        </LazyFigure>
    );
};
